<template>
  <a v-if="href" :href="href" :class="classObject" @click="handleClick">
    {{ text }}
    <slot />
  </a>
  <span v-else :class="classObject" @click="handleClick">
    {{ text }}
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    default: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Boolean,
      default: false,
    },
    warning: {
      type: Boolean,
      default: false,
    },
    danger: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
    quiet: {
      type: Boolean,
      default: false,
    },
    basic: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
    text: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
  },
  computed: {
    classObject() {
      return {
        label: true,
        'f-700': true,
        ucase: this.uppercase,
        [this.colorSchemeClass]: true,
        faded: this.quiet,
      }
    },
    colorSchemeClass() {
      const colorScheme = [
        'white',
        'quiet',
        'basic',
        'default',
        'primary',
        'success',
        'info',
        'warning',
        'danger',
      ].find((colorSchemeOption) => this[colorSchemeOption])
      return `label-${colorScheme || 'default'}`
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>
